import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Container, Card, Button, Spinner } from "react-bootstrap";
import NavbarComponent from "./DashboardNavbar.js";
import Swal from "sweetalert2";
import "./Dashboard.css";
 
const API_URL = process.env.REACT_APP_API_URL_EC2; // Load API URL from env
const token = process.env.REACT_APP_API_TOKEN; 

const ProductDetails = () => {
  const { category,price,title,image,slink } = useParams(); // Get parameters from URL
  const [product, setProduct] = useState(null); // State to store product data
  const [email, setemail] = useState();
  const [id, setid] = useState();

  const decodedTitle = decodeURIComponent(title);
  const decodedImage = decodeURIComponent(image);
  const decodedSlink = decodeURIComponent(slink);
  useEffect(() => {
    const storedUserdata = sessionStorage.getItem("user");
    if (storedUserdata) {
      const data = JSON.parse(storedUserdata);
      if (data.id) {
        setid(data.id);
        setemail(data.email);
      } else {
        console.error("ID is not available in stored user data.");
      }
    }
  }, []);

  useEffect(() => {
    console.log("Params received:", { category, title, image, slink });
  }, [category, title, image, slink]);

  const handleNotify = async () => {
    try {
      // Get the token from your environment variable
      
      
      // Set headers with the Bearer token
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      console.log(headers)
      // Send the POST request with headers and product data
      const response = await axios.post(
        `${API_URL}/api/sendemail`,
        {
          userId: 1,
          subject: "Product Notification",
          message : `Product Name: ${decodedTitle}, Price: $${price}, Link: ${decodedSlink}`,
          email : email

        },
        { headers } // Include headers in the request
      );
  
      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "success",
          text: "Notification Send",
          confirmButtonText: "OK",
        });
      }
      // Handle the response as needed (e.g., show a success message to the user)
    } catch (error) {
      console.error("Error sending email:", error);
      // Handle error accordingly (e.g., show an error message to the user)
    }
  };

  return (
    <div className="main-content">
      <NavbarComponent />
      <Container className="py-4">
        <Card className="shadow-lg text-center">
          {category ? (
            <>
              <Card.Img
                variant="top"
                src={decodedImage}
                alt={decodedTitle}
                style={{
                  width: "100%",
                  maxHeight: "400px",
                  objectFit: "contain",
                  margin: "0 auto",
                }}
              />
              <Card.Body>
                <Card.Title>{decodedTitle}</Card.Title>
                <Card.Text className="text-muted">
                  Category: {category}
                </Card.Text>
                <Card.Text className="fw-bold">Price: ${price}</Card.Text>
                <Card.Text className="fw-bold">
                  <a href={decodedSlink} target="_blank" rel="noopener noreferrer">
                    Click Here
                  </a>
                </Card.Text>
                <Button variant="success" onClick={handleNotify}>
                  Notify
                </Button>
              </Card.Body>
            </>
          ) : (
            <p>Product details are not available.</p>
          )}
        </Card>
      </Container>
    </div>
  );
};

export default ProductDetails;
